import React from 'react';

import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import Nav from 'react-bootstrap/Nav';

import { logOut } from '@src/components/helpers';

import LogoutModal from './LogoutModal';

class HeaderLogoutItem extends React.PureComponent {
    static propTypes = {
        displayName: PropTypes.string,
    };

    constructor(props) {
        super(props);
        // eslint-disable-next-line react/state-in-constructor
        this.state = {
            showConfirmationModal: false,
        };
    }

    handleItemClick = () => {
        this.setState({ showConfirmationModal: true });
    };

    handleCancel = () => {
        this.setState({ showConfirmationModal: false });
    };

    handleLogout = () => {
        this.setState({ showConfirmationModal: false });
        logOut(window.location.href);
    };

    render() {
        const { displayName } = this.props;
        const { showConfirmationModal } = this.state;

        return (
            <>
                <Nav.Item className="logout-item">
                    <Button variant="outline-primary" tabIndex={1000} onClick={this.handleItemClick}>
                        { displayName }
                    </Button>
                </Nav.Item>
                {
                    showConfirmationModal
                    && <LogoutModal
                        show={this.state.showConfirmationModal}
                        handleLogout={this.handleLogout}
                        handleCancel={this.handleCancel}
                    />
                }
            </>
        );
    }
}

export default HeaderLogoutItem;
